import {
  List,
  Datagrid,
  TextField,
  TextInput,
  DateField,
  ReferenceField,
  AutocompleteInput,
  ReferenceInput,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const B2BUserFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Email" source="email" alwaysOn />
    <ReferenceInput
      label="Organization"
      source="organizationId"
      reference="b2b-organizations"
      alwaysOn>
      <AutocompleteInput
        optionText="name"
        filterToQuery={searchText => ({
          name: { $iLike: `%${searchText}%` },
        })}
      />
    </ReferenceInput>
  </FilterComponent>
)

const B2BUserList = props => (
  <List
    {...props}
    filters={<B2BUserFilter />}
    bulkActionButtons={false}
    sort={{ field: 'updatedAt', order: 'DESC' }}>
    <Datagrid bulkActionButtons={true}>
      <TextField source="id" label="ID" />
      <ReferenceField
        reference="b2b-organizations"
        source="organization.id"
        label="Organization ID">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="email" />
      <TextField source="currentOtp" label="Current OTP" />
      <DateField source="createdAt" />
      {/*<EditButton basePath="/b2b-users" />*/}
    </Datagrid>
  </List>
)

export default B2BUserList
